// extracted by mini-css-extract-plugin
export default {"navWrapper":"Navbar_navWrapper__zBk4O","logoutButton":"Navbar_logoutButton__3vrUQ"};